import * as React from 'react'
import { useEffect } from 'react'
import type { GridRowId } from '@mui/x-data-grid-pro'

import { bulkActionReducer } from './reducer'
import { BulkActionContext } from './context'

type Props = {
  selectedRows: GridRowId[]
  children: React.ReactNode
}

export function BulkActionContextProvider(props: Props) {
  const { selectedRows, children } = props

  const [state, dispatch] = React.useReducer(bulkActionReducer, {
    errors: new Map(),
    isValidating: false,
  })

  useEffect(() => {
    if (selectedRows.length === 0) {
      dispatch({ type: 'setActive' })
    }
  }, [selectedRows.length])

  return (
    <BulkActionContext.Provider value={{ selectedRows, state, dispatch }}>
      {children}
    </BulkActionContext.Provider>
  )
}
